import SingleNewsPage from '~/modules/News/SingleNewsPage';
import { GetStaticPaths } from 'next';
import { createCommonGetStaticProps } from '~/lib/server/createCommonGetStaticProps';

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps = createCommonGetStaticProps([
  'bridgeStatus',
  'account',
  'common',
  'error',
]);

SingleNewsPage.getLayout = function getLayout(page) {
  return page;
};

export default SingleNewsPage;
